import { reactive } from 'vue'

const notifications = reactive([])

const addNotification = (type = 'success', title = null, description = null, duration = null) => {
    notifications.push({
        id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
        title: title,
        description: description,
        type: type,
        duration: duration,
    })
}

const deleteNotification = (id) => {
    let ind = notifications.findIndex(n => n.id == id);
    if (ind > -1) {
        notifications.splice(ind, 1)
    }
}

export default {
    notifications,
    addNotification,
    deleteNotification,
}
